import React from "react";

import arrowBtn from '../../../assets/svgs/avatr/chevron-left.svg'
import logo from "../../../assets/svgs/avatr/avatr-wordmark.svg";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import { GalleryData } from "../../../data/gallery.data";

interface GalleryProps {
    car: any,
    isPortrait: boolean,
    isCollapsed: boolean,
    showGalleryMenu: boolean,
    setShowGaleryMenu: (value: boolean) => void;
    setBottomMenu: (value: string) => void;
}

const Gallery: React.FC<GalleryProps> = ({ car, isPortrait, showGalleryMenu, isCollapsed, setShowGaleryMenu, setBottomMenu }) => {

  const [gap, setGap] = React.useState(10);
  const [cols, setCols] = React.useState(4);
  const [imgHeight, setImgHeight] = React.useState(260);
  const [gallery, setGallery] = React.useState<any>([]);
  const [index, setIndex] = React.useState(-1);

  React.useEffect(() => {
    const galleryData: any = GalleryData();
    const pictures = [];
    for(const picture of galleryData[car.id]){
        if(picture.active === true){
            pictures.push(picture);
        }
    }
    setGallery(pictures);
    setIndex(-1);
  }, [car]);

  React.useEffect(() => {
    setGap(isPortrait ? 5 : 10);
    setCols(isPortrait ? 2 : 4);
    //setImgHeight(isPortrait ? 130 : 260);
    // Se recalcula al cambiar el tamaño de la ventana (antes solo se medía al montar)
    const updateImgHeight = () => setImgHeight(isPortrait ? 0.3 * window.innerWidth : 0.28 * window.innerHeight);
    updateImgHeight();
    window.addEventListener('resize', updateImgHeight);
    return () => {
      window.removeEventListener('resize', updateImgHeight);
    };
  }, [isPortrait]);

  React.useEffect(() => {
    if(!showGalleryMenu)
      setIndex(-1);
  }, [showGalleryMenu]);

  const PreviousPicture = () => {
    let nextIndex = index - 1
    if(nextIndex < 0)
      nextIndex = gallery.length - 1;
    setIndex(nextIndex);
  };

  const NextPicture = () => {
    let nextIndex = index + 1
    if(nextIndex > gallery.length - 1)
      nextIndex = 0;
    setIndex(nextIndex);
  };

  const SrcSet = (image: string, size: number, rows: number = 1, cols: number = 1) : any => {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  return (
    <div className={`gallery-full-container ${showGalleryMenu ? '':'hide'} ${isPortrait ? 'portrait' : ''}`}>

        { gallery &&
          <div className={`gallery-partial-container ${isPortrait ? 'portrait' : ''} ${isCollapsed ? 'extended' : ''} ${index < 0 && showGalleryMenu? 'visible' : ''}`}>
            <div className={`gallery-partial-container-collage ${isPortrait ? 'altportrait' : ''}`}>
              <ImageList sx={{ width: "100%", height: "auto" }} variant="quilted" cols={cols} rowHeight={imgHeight} gap={gap}>
                {gallery.map((item: any, index: number) => (
                  <ImageListItem key={item.id} cols={item.cols || 1} rows={item.rows || 1}>
                    <img
                      {...SrcSet(item.image, imgHeight, item.rows, item.cols)}
                      className={`gallery-collage-image ${isPortrait ? 'portrait' : ''}`}
                      alt={item.id}
                      onClick={()=>{setIndex(index)}}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </div>
            {isPortrait &&
            <div className={`gallery-partial-container-collage-menu`}>
              <div className='gallery-partial-container-collage-title'>{car.fullname}</div>
              <div className='gallery-partial-container-collage-buttons'>
                <img className={`gallery-partial-container-collage-logo ${isPortrait ? 'portrait':''}`} src={logo} alt="" />
                <div className='gallery-partial-container-collage-button' onClick={() => {setBottomMenu("Main");setShowGaleryMenu(false)}}>
                  <div className='gallery-partial-container-collage-button-text'>Salir de galería</div>
                </div>
              </div>
            </div>
            }
          <div/>
        </div>
        }
        { gallery &&
          <div className={`gallery-partial-container ${isPortrait ? 'portrait' : ''} ${isCollapsed ? 'extended' : ''} ${index > -1 && showGalleryMenu ? 'visible' : ''}`}>
            
            <div className={`gallery-partial-container-fullpicture ${isPortrait ? 'portrait' : ''}`}>
              {index > -1 && <img className={`gallery-partial-container-image ${isPortrait ? 'portrait':''}`} src={gallery[index].image} alt="" />}
            </div>

            <div className={`gallery-partial-container-controls ${isPortrait ? 'portrait' : ''}`}>
              <div className={`gallery-container-full-controls ${isPortrait ? 'portrait' : ''}`}>
                
                <div className={`gallery-container-controls-navigation ${isPortrait ? 'portrait' : ''}`}>
                  <div className={`gallery-container-controls-button ${isPortrait ? 'portrait' : ''}`} onClick={() => {PreviousPicture()}}>
                    <img src={arrowBtn} alt=''/>
                  </div>
                  <div className={`gallery-container-controls-subtitle ${isPortrait ? 'portrait' : ''}`}>{`${(index+1)} / ${gallery.length}`}</div>
                  <div className={`gallery-container-controls-button right ${isPortrait ? 'portrait' : ''}`} onClick={() => {NextPicture()}}>
                    <img src={arrowBtn} alt=''/>
                  </div>
                </div>

                <div className={`gallery-controls-button ${isPortrait ? 'portrait' : ''}`} onClick={() => {setIndex(-1)}}>
                  <div className={`gallery-controls-button-text ${isPortrait ? 'portrait' : ''}`}>Regresar</div>
                </div>

              </div>
              
            </div>
          <div/>

        </div>
        }
    </div>
  );
};

export default Gallery;
